// extracted by mini-css-extract-plugin
export default {"modalBody":"_3ON3e","spinnerContainer":"MjQv5","modalBodyScroll":"_7o0mh","footerCancelButton":"_3uW4r","content":"zvgcj"};